module.exports = __webpack_public_path__ + "static/media/Week 6 Saturday.0ccf2454.png";